var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "easy-register-wrap" }, [
    _c("h2", [
      _vm._v(" 간편처방 등록 "),
      _c("span", { staticClass: "more-text" }, [
        _vm._v(
          " " +
            _vm._s(
              _vm.suffleDrugLandings.length === 0
                ? "쉽고 빠르게 의약품을 등록할 수 있는 서비스입니다"
                : "쉽고 빠르게 의약품을 등록해 보세요"
            ) +
            " "
        ),
      ]),
    ]),
    _c(
      "div",
      { staticClass: "easy-register-items" },
      [
        _vm.suffleDrugLandings.length === 0
          ? _c("p", { staticClass: "easy-register-empty" }, [
              _vm._v(" 현재 등록을 추천할 의약품을 준비 중입니다 "),
            ])
          : _vm._l(_vm.suffleDrugLandings, function (item, i) {
              return _c(
                "div",
                {
                  key: i,
                  staticClass: "easy-register-item",
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.handleDrugLandingClick(item.liveInfoId)
                    },
                  },
                },
                [
                  _c("p", { staticClass: "easy-register-txt" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          item.title.length > 22
                            ? item.title.substring(0, 22)
                            : item.title
                        ) +
                        " "
                    ),
                  ]),
                  _c("i"),
                ]
              )
            }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }